// extracted by mini-css-extract-plugin
export default {"fixBottom":"index_fixBottom_rOiJ4","activityImage":"index_activityImage_jiiLa"};